import { createContext } from "react";
import { BoatDataModel } from "../models/boatDataModel";

export interface BoatDataContextState extends BoatDataModel {
    estimatedTimeBehindNextBoatMs?: number;
    estimatedProgress?: number;
}

export const BoatDataContext = createContext<BoatDataContextState[]>([]);
